import { FormControl } from 'baseui/form-control';
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader, SIZE } from 'baseui/modal';
import { useState } from 'react';
import { getValue } from '../utils';
import { TValueOption, ValueCellSelector } from '../components/ValueCellSelector';
import { useIntl, FormattedMessage } from 'react-intl';
import { addMinutes } from 'date-fns';
import { default as EditTimeRangeForm } from '../components/EditTimeRangeForm';
import { styled, useStyletron } from 'baseui';
import { Button } from 'baseui/button';
import { HorizontalStackPanel } from '../../../../components/Layout/StackPanel';

export interface EditEventDialogProps {
    isOpen: boolean,
    setIsOpen: any,
    onAccept: (state: { value: number | boolean | undefined | null, timeFrom: Date, timeTo: Date }, eventId: string) => void,
    onDelete?: (eventId: string) => void | undefined,
    value: number | boolean | undefined | null,
    eventId: string,
    dataType: string,
    timeFrom: Date,
    timeTo: Date
    valueOptions?: TValueOption[] | undefined // if value is an enum - provide possible values here
}

export const EditEntryDialog = (props: EditEventDialogProps) => {
    const intl = useIntl();
    const [css, theme] = useStyletron()
    const [state, setState] = useState({ value: getValue(props.dataType, props.value), timeFrom: props.timeFrom, timeTo: props.timeTo });

    function onValueChanged(newValue: any) {
        setState(prevState => ({
            ...prevState,     // keep all other key-value pairs
            value: newValue
        }))

    }
    function setTimeFrom(time: Date | null) {
        if (!time)
            return;

        if (time >= state.timeTo)
            time = addMinutes(state.timeTo, -15);

        setState(prevState => ({
            ...prevState,     // keep all other key-value pairs
            timeFrom: time as Date
        }))
    }
    function setTimeTo(time: Date | null) {
        if (!time)
            return;

        if (time <= props.timeFrom)
            time = addMinutes(props.timeFrom, 15);

        setState(prevState => ({
            ...prevState,     // keep all other key-value pairs
            timeTo: time as Date
        }))
    }

    const handleDelete = () => { if (props.onDelete) props.onDelete(props.eventId); props.setIsOpen(false) }

    return (
        <Modal closeable onClose={() => props.setIsOpen(false)} isOpen={props.isOpen}>
            <ModalHeader><FormattedMessage id="Scheduler.EditValue" defaultMessage="Edit Value" /></ModalHeader>
            <ModalBody>
                <EditTimeRangeForm timeFrom={state.timeFrom} timeTo={state.timeTo} onTimeFromChange={setTimeFrom} onTimeToChange={setTimeTo}></EditTimeRangeForm>
                <FormControl
                    label={() => intl.formatMessage({ id: "valueInput", defaultMessage: "Value" })}
                    caption={() => intl.formatMessage({ id: "valueInputDescription", defaultMessage: "Select a value" })}
                >
                    <ValueCellSelector valueOptions={props.valueOptions} dataType={props.dataType} value={state.value} onValueChanged={onValueChanged}></ValueCellSelector>
                </FormControl>

            </ModalBody>
            <ModalFooter>
                <ButtonsContainer>
                    {props.onDelete && <Button onClick={handleDelete} size='compact' overrides={{
                        BaseButton: {
                            style: ({ $theme }) => ({
                                backgroundColor: $theme.colors.negative
                            })
                        }
                    }}><FormattedMessage id="delete"></FormattedMessage></Button>}
                    <HorizontalStackPanel>                    <ModalButton size='compact' kind="tertiary" onClick={() => { props.setIsOpen(false); }}>
                        <FormattedMessage id="cancel" defaultMessage="Cancel" />
                    </ModalButton>
                        <ModalButton size='compact' onClick={() => { props.onAccept(state, props.eventId); props.setIsOpen(false) }}> <FormattedMessage id="ok" defaultMessage="Ok" /></ModalButton>

                    </HorizontalStackPanel>
                </ButtonsContainer>
            </ModalFooter>
        </Modal >
    );
}




const ButtonsContainer = styled<'div', {}>("div", ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gridGap: $theme.sizing.scale300
}));